const faqSection = document.querySelector("div.shopify-section.section-wrapper:has(span.faq-section) div.group-block-content");
const details = faqSection.querySelectorAll("accordion-custom details");

details.forEach((targetDetail) => {
  targetDetail.addEventListener("toggle", () => {
    
    // If opened, close all others
    if (targetDetail.open) {
      details.forEach((detail) => {
        if (detail !== targetDetail) {
          detail.open = false;
        }
      });
    }

  });
});

const menuItemsContainer = document.querySelector("header header-drawer.header__drawer--mobile");
const menuItems = menuItemsContainer.querySelectorAll('.menu-drawer__menu-item');

menuItems.forEach((item) => {
  item.addEventListener("click", () => {
    
    if (menuItemsContainer.querySelector('details').open) {
      menuItemsContainer.querySelector('.menu-drawer__close-button').click();
    }

  });
});

// window.addEventListener("load", () => {
// const formPopup = document.querySelector('shopify-forms-embed');

//   console.log(formPopup);
// if (formPopup?.shadowRoot) {
//   //const formPopup = form.shadowRoot.querySelector('section[data-sizing="form-wrapper"]');

//   if (popup) {
//     const style = document.createElement('style');
//     style.textContent = `
//       :host {
//         --col-size: 410px !important;
//       }
//     `;
//     formPopup.shadowRoot.appendChild(style);
//   }
// }
// });